import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

declare var jQuery;

@Component({
  selector: 'app-interactive-elements',
  templateUrl: './app-interactive-elements.html',
  styleUrls: ['./app-interactive-elements.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppInteractiveElements implements OnInit {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Output() anchorClick = new EventEmitter<string>();

  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];
  tooltipMap = {
    'Shares Info':
      'if the app can share your personal information with third-parties, eg Instagram, Viber, and most social apps',
    'Shares Location':
      'if the app can show your location to other users, eg Instagram, Viber, and most social apps',
    'Users Interact':
      'if there’s user-generated content inside the app that may be unfiltered or uncensored by the developers, eg Instagram, Viber, and most social apps',
    'Digital Purchases':
      'if the app allows you to make purchases, eg Amazon Shopping',
    'Unrestricted Internet':
      '- if the app has complete access to the Internet, eg Firefox, Chrome'
  };

  ngOnInit() {}

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
